import angular from 'angular';

class rebroadcastCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $uibModal,
        $sessionStorage,
        toastr,
        $translate,
        uiGridConstants,
        dateFilter,
        AuthSvc,
        LadProviderService,
        BatchService,
        DateService,
        BATCH_STATUS_REBROADCAST,
        UtilSvc
    ) {
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$sessionStorage = $sessionStorage;
        this.toastr = toastr;
        this.$translate = $translate;
        this.uiGridConstants = uiGridConstants;
        this.dateFilter = dateFilter;
        this.AuthSvc = AuthSvc;
        this.LadProviderService = LadProviderService;
        this.BatchService = BatchService;
        this.DateService = DateService;
        this.BATCH_STATUS_REBROADCAST = BATCH_STATUS_REBROADCAST;
        this.UtilSvc = UtilSvc;
    }

    $onInit() {
        // Accès raccourcis aux autorisations depuis le scope principal
        this.isAuthorized = this.AuthSvc.isAuthorized;
        this.includes = {
            formMessages: require('../../../common/form-messages.html'),
        };

        var specificForm = this.specificFormRebroadcast;

        this.criteria = {
            batchIds: [],
            envelopeId: [],
            ladProviderId: [],
            batchStatus: [],
            isQuali: [],
            ihmBroadcast: true,
        };

        this.criteriaDates = {
            createdDateFrom: [],
            createdDateTo: [],
            createdTimeFrom: [],
            createdTimeTo: [],
            updatedDateFrom: [],
            updatedDateTo: [],
            updatedTimeFrom: [],
            updatedTimeTo: [],
            requestedDateFrom: [],
            requestedDateTo: [],
            requestedTimeFrom: [],
            requestedTimeTo: [],
        };

        this.batchsStatus = this.BATCH_STATUS_REBROADCAST;
        this.ladProviders = this.LadProviderService.findAll();
        this._initBatchsSearchFilter();
        this._initBatchsSearchValues();

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="batch_details({ batchId : row.entity.batchId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        var isQualiCellTemplate =
            '<a class="grid-cell-link" ui-sref="batch_details({ batchId : row.entity.batchId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{"IS_QUALI_"+COL_FIELD | translate}}</div></a>';

        this.gridOptions = {
            columnDefs: [
                {
                    name: 'batchId',
                    displayName: 'dashboard.column.batch.batch.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    type: 'number',
                },
                {
                    name: 'created',
                    displayName: 'dashboard.column.envelope.created',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    sort: { direction: this.uiGridConstants.DESC, priority: 0 },
                    cellFilter: "date:'shortDate'",
                },
                {
                    name: 'requested',
                    displayName: 'process.rebroadcast.form.requested',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: "date:'shortDate'",
                },
                {
                    name: 'batchStatus',
                    displayName: 'dashboard.column.envelope.status',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: 'translate',
                },
                {
                    name: 'isQuali',
                    displayName: 'dashboard.column.batch.target',
                    cellTemplate: isQualiCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'ladProviderName',
                    displayName: 'dashboard.column.batch.ladProvider',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'envelopeId',
                    displayName: 'dashboard.column.envelope.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    type: 'number',
                },
                {
                    name: 'envelopeCreationTime',
                    displayName: 'process.rebroadcast.form.envelope.creation',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: "date:'shortDate'",
                },
            ],
            enableGridMenu: false,
            enableRowSelection: true,
            enableSelectAll: true,
            selectionRowHeaderWidth: 30,
            exporterMenuCsv: false,
            exporterMenuPdf: false,
            enableColumnMenus: false,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            exporterHeaderFilter: this.$translate.instant,
            exporterFieldCallback: (grid, row, col, value) => {
                if (col.name === 'created' || col.name === 'requested' || col.name === 'envelopeCreationTime') {
                    value = this.dateFilter(value, 'shortDate');
                } else if (col.name === 'batchStatus') {
                    value = this.$translate.instant(value);
                } else if (col.name === 'isQuali') {
                    value = this.$translate.instant('IS_QUALI_' + value);
                }
                return value;
            },
            gridMenuTitleFilter: this.$translate,
            onRegisterApi: gridApi => {
                this.gridBatchApi = gridApi;
            },
        };

        var rebroadcastHistorySearchCriteria = this.$sessionStorage.rebroadcastHistorySearchCriteria;
        if (rebroadcastHistorySearchCriteria && !specificForm) {
            this.criteria = rebroadcastHistorySearchCriteria;
        }
    }

    clearSearchBatchs() {
        this._initBatchsSearchFilter();
        this._initBatchsSearchValues();
        this.gridOptions.data = this._searchByCriterias();
        this.$sessionStorage.rebroadcastHistorySearchCriteria = this.criteria;
    }

    searchBatchs() {
        this._cleanBatchsFormParam();
        this.gridOptions.data = this._searchByCriterias();
        this.rebroadcastPromise = this.gridOptions.data.$promise;
        this.$sessionStorage.rebroadcastHistorySearchCriteria = this.criteria;
    }

    // Indique si l'export CSV de la grille peut être réalisé
    canExportGridCsv() {
        if (!(this.gridBatchApi === undefined || this.gridBatchApi.selection === undefined)) {
            return this.gridBatchApi.selection.getSelectedRows().length > 0;
        }
        return false;
    }

    // Exporte toutes les colonnes des lignes sélectionnées dans un fichier CSV
    exportGridCsv() {
        // Nom du fichier CSV : epdf_DateHeure_dataLots.csv
        var now = new Date();
        var filename = 'epdf_' + this.DateService.formatAsYMD_HM(now) + '_dataLots.csv';
        this.gridOptions.exporterCsvFilename = filename;

        var myElement = angular.element(document.querySelectorAll('.custom-csv-link-location'));
        this.gridBatchApi.exporter.csvExport('selected', 'all', myElement);
    }

    rebroadcastBatch() {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: require('./rebroadcast-modal-confirm.html'),
            controller: 'RebroadcastModalConfirmCtrl',
            resolve: {
                nbSelected: () => {
                    return this.gridBatchApi.selection.getSelectedRows().length;
                },
            },
        });
        modalInstance.result.then(motif => {
            var batchIds = [];
            var selectedRows = this.gridBatchApi.selection.getSelectedRows();
            for (var i = 0; i < selectedRows.length; i++) {
                batchIds.push(selectedRows[i].batchId);
            }
            this.BatchService.rebroadcast({ batchIds: batchIds, motif: motif }, () => {
                this.toastr.success(
                    this.$translate.instant('process.rebroadcast.toaster.body'),
                    this.$translate.instant('process.rebroadcast.toaster.title'),
                    { timeOut: 7000 }
                );
                this.searchBatchs();
            });
        });
    }

    _searchByCriterias() {
        var criterias = angular.copy(this.criteria);
        if (criterias.batchIds) {
            const stringArray = criterias.batchIds.split(';');
            criterias.batchIds = stringArray.map(str => parseInt(str));
        } else {
            criterias.batchIds = [];
        }
        var createdDateFrom = this.UtilSvc.mixteDateTime(
            this.criteriaDates.createdDateFrom,
            this.criteriaDates.createdTimeFrom
        );
        criterias.createdDateFrom = createdDateFrom;
        var createdDateTo = this.UtilSvc.mixteDateTime(
            this.criteriaDates.createdDateTo,
            this.criteriaDates.createdTimeTo
        );
        criterias.createdDateTo = createdDateTo;
        var updatedDateFrom = this.UtilSvc.mixteDateTime(
            this.criteriaDates.updatedDateFrom,
            this.criteriaDates.updatedTimeFrom
        );
        criterias.updatedDateFrom = updatedDateFrom;
        var updatedDateTo = this.UtilSvc.mixteDateTime(
            this.criteriaDates.updatedDateTo,
            this.criteriaDates.updatedTimeTo
        );
        criterias.updatedDateTo = updatedDateTo;
        var requestedDateFrom = this.UtilSvc.mixteDateTime(
            this.criteriaDates.requestedDateFrom,
            this.criteriaDates.requestedTimeFrom
        );
        criterias.updatedDateFrom = requestedDateFrom;
        var requestedDateTo = this.UtilSvc.mixteDateTime(
            this.criteriaDates.requestedDateTo,
            this.criteriaDates.requestedTimeTo
        );
        criterias.updatedDateTo = requestedDateTo;

        return this.BatchService.searchByCriterias(criterias);
    }

    _initBatchsSearchValues() {
        this.criteriaDates.createdTimeFrom = new Date();
        this.criteriaDates.createdTimeFrom.setHours(0, 0, 0, 0);
        this.criteriaDates.createdTimeTo = new Date();
        this.criteriaDates.createdTimeTo.setHours(23, 59, 0, 0);
        this.criteriaDates.updatedTimeFrom = new Date();
        this.criteriaDates.updatedTimeFrom.setHours(0, 0, 0, 0);
        this.criteriaDates.updatedTimeTo = new Date();
        this.criteriaDates.updatedTimeTo.setHours(23, 59, 0, 0);
        this.criteriaDates.requestedTimeFrom = new Date();
        this.criteriaDates.requestedTimeFrom.setHours(0, 0, 0, 0);
        this.criteriaDates.requestedTimeTo = new Date();
        this.criteriaDates.requestedTimeTo.setHours(23, 59, 0, 0);
        this.criteria.batchStatus = this.BATCH_STATUS_REBROADCAST[0];
    }

    _cleanBatchsFormParam() {
        if (this.criteria.batchStatus == '') {
            this.criteria.batchStatus = undefined;
        }
    }

    _initBatchsSearchFilter() {
        this.criteria.batchIds = undefined;
        this.criteria.batchStatus = undefined;
        this.criteria.ladProviderId = undefined;
        this.criteria.envelopeId = undefined;
        this.criteria.isQuali = undefined;
        this.criteriaDates.createdDateFrom = undefined;
        this.criteriaDates.createdDateTo = undefined;
        this.criteriaDates.createdTimeFrom = undefined;
        this.criteriaDates.createdTimeTo = undefined;
        this.criteriaDates.updatedDateFrom = undefined;
        this.criteriaDates.updatedDateTo = undefined;
        this.criteriaDates.updatedTimeFrom = undefined;
        this.criteriaDates.updatedTimeTo = undefined;
        this.criteriaDates.requestedDateFrom = undefined;
        this.criteriaDates.requestedDateTo = undefined;
        this.criteriaDates.requestedTimeFrom = undefined;
        this.criteriaDates.requestedTimeTo = undefined;
    }
}

angular.module('rebroadcast').component('rebroadcast', {
    templateUrl: require('./rebroadcast.html'),
    controller: rebroadcastCtrl,
});
